import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, AdvertiseData } from './types'

export const selectAdvertiseListEvent = (state: RootState): Event => state.advertiseReducer.listEvent

export const selectAdvertiseList = (state: RootState): ListData => state.advertiseReducer.list

export const selectAdvertiseActionEvent = (state: RootState): Event => state.advertiseReducer.actionEvent

export const selectAdvertiseDetail = (state: RootState): AdvertiseData | undefined =>
  state.advertiseReducer.detail

export const selectAdvertiseDetailEvent = (state: RootState): Event => state.advertiseReducer.detailEvent
